// @flow
import React from 'react';
import Textarea from 'react-textarea-autosize';
import TextInput from './TextInput';

export default class TextareaInput extends TextInput {
  render() {
    return (
      <Textarea
        className={this.props.className}
        type={this.inputType}
        placeholder={this.props.placeholder}
        value={this.domValue}
        name={this.parent ? this.name : ''}
        onChange={ev => {
          this.inputDidChange(ev.target.value);
        }}
        onBlur={() => {
          this.inputDidCommitChange();
        }}
        onFocus={() => {
          if (this.props.onFocus && typeof this.props.onFocus === 'function') {
            this.props.onFocus(this.api);
          }
        }}
      />
    );
  }
}
